import { gql } from "graphql-request";

import { FRAGMENT_EMPLOYEE_PREFERENCES, FRAGMENT_OWNER } from "./fragments";

export const MUTATION_CREATE_DELIVERY_EVENT = gql`
  mutation createDeliveryEvent($input: CreateDeliverInput!) {
    createDeliveryEvent(input: $input) {
      id
      receiver {
        id
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${FRAGMENT_EMPLOYEE_PREFERENCES}
`;

export const MUTATION_CREATE_GUEST_VISITOR = gql`
  mutation createGuestVisitor($input: CreateGuestVisitor!) {
    createGuestVisitor(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_ACCESS_SCAN = gql`
  mutation accessScan($input: MemberAccessCheckInInput!) {
    accessScan(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      metadata
      receiver {
        id
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_CREATE_SCREEN_EVENT = gql`
  mutation createScreenEvent($input: CreateScreenEventInput!) {
    createScreenEvent(input: $input) {
      id
    }
  }
`;

export const MUTATION_CREATE_GUEST = gql`
  mutation createGuest($input: CreateGuest!) {
    createGuest(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_CHECKOUT_OWNER = gql`
  mutation checkOutOwner($id: ID!) {
    checkOutOwner(id: $id) {
      id
    }
  }
`;

export const MUTATION_CREATE_CUSTOM_DELIVERY_EVENT = gql`
  mutation createCustomDeliveryEvent($input: CreateCustomDeliveryInput!) {
    createCustomDeliveryEvent(input: $input) {
      id
      customReceiver {
        phone
      }
    }
  }
`;

export const MUTATION_CREATE_VIDEO_ROOM = gql`
  mutation accessEventCreateVideoRoom($id: ID!) {
    accessEventCreateVideoRoom(id: $id) {
      id
      roomUrl
    }
  }
`;

export const MUTATION_DELETE_VIDEO_ROOM = gql`
  mutation accessEventDeleteVideoRoom($id: ID!) {
    accessEventDeleteVideoRoom(id: $id)
  }
`;
